import React from 'react';

import { Box, Chip } from '@mui/material';
import { matchPath, useLocation, useNavigate } from 'react-router';

import { appRoutes, RouterEntitiesId } from '@clearverify/constants';
import { getDateTimeInTimezone } from '@clearverify/utils';

import { CLEARVERIFY_LOGO_SM_SQUARE } from 'src/assets';
import { Avatar } from 'src/components/shared';
import { useCurrentUser } from 'src/hooks/user';
import { SxProp } from 'src/types/mui';
import { buildUrl } from 'src/utils/router';

import { BaseInboxItemCard } from './BaseInboxItemCard';
import { InboxItemCardHeader } from './components';

interface ResourcesInboxItemCardProps {
  inboxItemId: string;
}

export const ResourcesInboxItemCard: React.FC<ResourcesInboxItemCardProps> = ({ inboxItemId }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const { user, timezone } = useCurrentUser();

  const inboxItemPath = buildUrl(appRoutes.inbox.inboxItem, {
    [RouterEntitiesId.inboxItem]: inboxItemId,
  });
  const isSelected = Boolean(matchPath({ path: inboxItemPath, end: true }, location.pathname));
  const createdAtDateUserTimezone = getDateTimeInTimezone(user?.createdAt, timezone)?.toISO();

  const navigateToDetails = React.useCallback(() => {
    navigate(inboxItemPath);
  }, [inboxItemPath, navigate]);

  return (
    <BaseInboxItemCard
      isSelected={isSelected}
      onClick={navigateToDetails}
      avatar={<Avatar sx={avatarStyles} src={CLEARVERIFY_LOGO_SM_SQUARE} variant="circular" />}
      title={
        <InboxItemCardHeader
          cardHeading="Clear Verify Team"
          lastUpdatedAt={createdAtDateUserTimezone}
          isUnreadStatus={false}
        />
      }
      subheader="Welcome to Clear Verify!"
      lastActivity="Clear Verify Team is happy to welcome you!"
    >
      <Box display="flex" justifyContent="flex-end" mt={2}>
        <Chip sx={chipStyles} label="Info" size="small" variant="filled" />
      </Box>
    </BaseInboxItemCard>
  );
};

const avatarStyles: SxProp = {
  border: theme => `1px solid ${theme.palette.divider}`,
};

const chipStyles: SxProp = {
  backgroundColor: 'rgba(0, 0, 0, 0.3)',
  color: '#ffffff',
};
